module.exports = __webpack_public_path__ + "static/img/RE.24fd396f.svg";